// Libs
import React from 'react';
import { ReactElement } from 'react';
import Link from 'next/link';
// UI components
import { Typography } from 'ui-components/';
// App
import { ActivateCallbackErrorProps } from './page.interfaces';
import Section from 'app-shared/lib/layout/shared/section';
import { ActionButton, ActionButtons } from 'app-shared/lib/components/buttons';
import { isErrorContaining } from 'app-shared/lib/api/utils/axios-request.utils';
import { USER_ACCESS_PAGES_URLS } from '../user-access.constants';

/**
 * Error callback displayed when activate account failed
 */
const ActivateCallbackError = (props: ActivateCallbackErrorProps): ReactElement => {
  const { error } = props;

  let message = (
    <Typography color="primary">
      Une erreur s&apos;est produite lors de l&apos;activation de votre compte. <br />
    </Typography>
  );

  if (isErrorContaining(error, 'activation key')) {
    message = (
      <>
        <Typography>Votre compte est déja activé ou votre demande d&apos;activation est invalide.</Typography>
        <ActionButtons>
          <Link href={USER_ACCESS_PAGES_URLS['login']}>
            <ActionButton role="button" size="large" type="button">
              Se connecter
            </ActionButton>
          </Link>
        </ActionButtons>
      </>
    );
  }

  return <Section id="callback-error">{message}</Section>;
};

export default ActivateCallbackError;
